import { FC } from "react";

type Props = {
  message: string;
}

export const FrontErrorMessageArea: FC<Props> = (props: Props) => {
  const errorMessage = props.message;
  if (!errorMessage) return (<></>)
  return (
    <div className="error error_02" style={{margin: "20px 0"}}>
      <p>{errorMessage}</p>
    </div>
  )
}
